import { createApiSlice } from "@common";
import { CRUD_ACCOUNT_TYPE } from "@routes";

const apiConfig = [
  {
    name: "addAccountType",
    method: "post",
    url: CRUD_ACCOUNT_TYPE,
    stateKey: "message",
  },
  {
    name: "getAccountType",
    method: "get",
    url: CRUD_ACCOUNT_TYPE,
    stateKey: "data",
  },
  {
    name: "updateAccountType",
    method: "put",
    url: CRUD_ACCOUNT_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteAccountType",
    method: "delete",
    url: CRUD_ACCOUNT_TYPE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "accountType",
  apiConfig,
  customReducers);
const accountTypeSlice = slice;

export default accountTypeSlice.reducer;

export const {
  addAccountType,
  getAccountType,
  updateAccountType,
  deleteAccountType,
} = thunks;

export const { rowSelect } = actions;
